module.exports = __webpack_public_path__ + "static/media/clement-h-544786-unsplash.a1f31fae.jpg";